import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { StaticTextService, AboutService, ConfigService, AuthService } from '../../services';

@Component({
  selector: 'app-contact',
  templateUrl: './service.component.html',
  styleUrls: ['./service.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ServiceComponent implements OnInit {
  timer:any;
  constructor(
    public text:StaticTextService,
    private pages: AboutService,
    private config:ConfigService,
    private auth:AuthService
  ) { }

  ngOnInit() {
    this.timer=setTimeout(() => this.config.setSideBarNode(0), 0);
  }
  ngOnDestroy(){
    if(this.timer)clearTimeout(this.timer)
  }

  ngAfterViewInit() {
    this.auth.loadHubSpotChatToken();
  }

}
